import { render, staticRenderFns } from "./icon-tooltip.vue?vue&type=template&id=95317222&"
import script from "./icon-tooltip.vue?vue&type=script&lang=js&"
export * from "./icon-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports